import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import es from './locales/es.json'
import pt from './locales/pt.json'

const SUPPORTED = ['en', 'es', 'pt']

const detector = new LanguageDetector()
detector.addDetector({
  name: 'supportedPath',
  lookup() {
    const segments = window.location.pathname.split('/').filter(Boolean)
    if (segments.length > 0 && SUPPORTED.includes(segments[0])) {
      return segments[0]
    }
    return undefined
  },
  cacheUserLanguage() {}
})

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    detection: {
      order: ['supportedPath', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
